const Description = () => {
  return (
    <div className="px-3 mt-8">
      <p className=" font-extrabold text-gray-6 my-3">تعیین قیمت:</p>
      <p className="text-gray-6">
        زمان شروع حراجی، محصول در بالاترین قیمت به فروش می‌رسد. سپس تا آخرین
        مهلت تعیین شده حراجی، قیمت بصورت پلکانی به حداقل قیمت خود کاهش پیدا
        می‌کند.
      </p>
    </div>
  );
};

export default Description;
